export default __webpack_public_path__ + "static/media/Queen-Annes-Lace_L3.99af1f83.png";